import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from '../../components/Button/Button';

import styles from './auth.scss';

export default function Welcome() {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state || null;

    const { t } = useTranslation();

    return (
        <div className={styles.sign}>
            <div className={styles.top}>
                <h2>{t('welcome.main.title')}</h2>
                <p className={styles.text + ' ' + styles.center}>{t('welcome.main.description')}</p>
            </div>
            <div className={styles.bottom}>
                <Button
                    text={t('welcome.main.signIn')}
                    fill={true}
                    onClick={() => { navigate('./login', { state }); }}
                />
                <Button
                    level="secondary"
                    text={t('welcome.main.signUp')}
                    fill={true}
                    onClick={() => { navigate('./register', { state }); }}
                />
            </div>
        </div>
    );
};
